
























































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import BuilderDeviceProfileDetailsStub from '@/components/builder/BuilderDeviceProfileDetailsStub.vue'
import BuilderDeviceProfileCoverStub from '@/components/builder/BuilderDeviceProfileCoverStub.vue'
import BuilderDeviceProfileSubscriptionsStub from '@/components/builder/BuilderDeviceProfileSubscriptionsStub.vue'
import BuilderDeviceProfilePostsStub from '@/components/builder/BuilderDeviceProfilePostsStub.vue'
import BuilderDeviceProfileContentTypeStub from '@/components/builder/BuilderDeviceProfileContentTypeStub.vue'
import BuilderDeviceProfileHeaderStub from '@/components/builder/BuilderDeviceProfileHeaderStub.vue'
import BuilderDeviceFooterStub from '@/components/builder/BuilderDeviceProfileFooterStub.vue'
import BuilderDevice from '@/components/builder/BuilderDevice.vue'

interface Cover {
  id: number
  file: File | string | null
}

interface Subscription {
  id: number
  price: string | null
  duration: string | null
}

interface Post {
  id: number
  file: File | string | null
}

@Component({
  components: {
    BuilderDeviceProfilePostsStub,
    BuilderDeviceProfileSubscriptionsStub,
    BuilderDeviceProfileCoverStub,
    BuilderDeviceProfileDetailsStub,
    BuilderDeviceProfileHeaderStub,
    BuilderDeviceFooterStub,
    BuilderDeviceProfileContentTypeStub,
    BuilderDevice,
  },
  computed: {
    ...mapGetters('builder', { appType: 'getAppType' })
  }
})
export default class BuilderDeviceProfileStub extends Vue {
  @Prop({ required: true, type: String }) color!: string

  @Prop({ default: 'none', type: String }) highlight!: string

  @Prop({ type: String }) siteName!: string | null

  @Prop({ required: true, type: Boolean }) blurProfile!: boolean

  @Prop({ required: true }) avatar!: File | string | null

  @Prop({ type: String }) description!: string | null

  @Prop({ required: true, type: Boolean }) blurCover!: boolean

  @Prop({ required: true, type: Array }) cover!: Cover[]

  @Prop({ required: true, type: Boolean }) blurSubscriptions!: boolean

  @Prop({ required: true, type: Boolean }) showSubscribeButton!: boolean

  @Prop({ required: true, type: Array }) subscriptions!: Subscription[]

  @Prop({ required: true, type: Boolean }) blurContentType!: boolean

  @Prop({ required: true, type: Boolean }) blurPosts!: boolean

  @Prop({ required: true, type: Array }) posts!: Post[]

  @Prop({ default: false, type: Boolean }) viewMode!: boolean
}
